import React from "react"
import "./CognitoForm.scss"
import { HTMLEmbed } from "terra-one"

const CognitoForm = ({ data }) => {
  if (!data) return <></>

  // Pass UTM parameters to Cognito Forms manually
  const htmlContent = {
    HTML: `
      <div class="cognito-wrapper">
        <div class="cognito"></div>
        <script src="https://www.cognitoforms.com/s/0cXQNplKOk-LZ2g6xRL5fQ"></script>
        <script type="text/javascript">
          (function() {
            // Function to get UTM parameters from sessionStorage
            function getUTMParams() {
              const paramsString = window.location.search
              const searchParams = new URLSearchParams(paramsString)
              const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_partner"];
              const utmParams = {};
              keys.forEach(key => {
                //const value = sessionStorage.getItem(key);
                // if (value) {
                //   const formattedKey = "UTM" + key.slice(4).charAt(0).toUpperCase() + key.slice(5);
                //   utmParams[formattedKey] = value;
                // }
                const formattedKey = "UTM" + key.slice(4).charAt(0).toUpperCase() + key.slice(5)
                utmParams[formattedKey] = searchParams.get(key)   

              });
              return utmParams;
            }

            const utmParams = getUTMParams();
            Cognito.load("forms", {
              id: ${data?.formId},
              entry: {
                ...utmParams,
                "FormReferrerURL": "https://" + window.location.hostname + window.location.pathname,
              }
            });
          })();
        </script>
      </div>
    `,
  }

  return <HTMLEmbed content={htmlContent}></HTMLEmbed>
}

export default CognitoForm
